import React, { useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { t, locale, user, basename } from '../i18n';

const bootstrap = window.__P4N__ || {};
const FLAG = (code) => `/img/flags/${code === 'en' ? 'gb' : code}.svg`;

/** Formulaire POST classique (logout, portail Stripe) avec jeton CSRF serveur. */
function PostForm({ action, className, children }) {
    return (
        <form method="POST" action={action} className={className}>
            <span dangerouslySetInnerHTML={{ __html: bootstrap.csrfInput || '' }} />
            {children}
        </form>
    );
}

function Sidebar({ open, onClose }) {
    return (
        <>
            <div className={`sidebar__overlay${open ? ' is-open' : ''}`} onClick={onClose} />
            <nav className={`sidebar${open ? ' is-open' : ''}`}>
                <div className="sidebar__logo">
                    <img src="/assets/ds/img/logo-horizontal.svg" alt="park4night" />
                </div>

                <div className="sidebar__eyebrow">{t('pages')}</div>
                <NavLink to="/" end className={({ isActive }) => `sidebar__link${isActive ? ' is-active' : ''}`} onClick={onClose}>
                    <img src="/assets/ds/icons/around_me_dark.svg" alt="" />
                    {t('dashboard')}
                </NavLink>

                <div className="sidebar__eyebrow">{t('account')}</div>
                {user && user.hasPremiumStripeSubscription && (
                    <PostForm action={bootstrap.urls.stripeDashboard}>
                        <button type="submit" className="sidebar__link">
                            <img src="/assets/ds/icons/shop_dark.svg" alt="" />
                            {t('manage_billing')}
                        </button>
                    </PostForm>
                )}
                <div className="sidebar__footer">
                    <PostForm action={bootstrap.urls.logout}>
                        <button type="submit" className="sidebar__link">
                            <img src="/assets/ds/icons/more_dark.svg" alt="" />
                            {t('deconnexion')}
                        </button>
                    </PostForm>
                </div>
            </nav>
        </>
    );
}

function LangSwitcher() {
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const locales = (bootstrap.locales || []).filter((code) => code !== locale);

    return (
        <div style={{ position: 'relative' }}>
            <button className="btn btn--secondary btn--sm" onClick={() => setOpen(!open)}>
                <img className="btn__icon" src={FLAG(locale)} alt={locale} style={{ borderRadius: 2 }} />
                {locale.toUpperCase()}
            </button>
            {open && (
                <div
                    className="card"
                    style={{ position: 'absolute', right: 0, top: 'calc(100% + 8px)', padding: 8, zIndex: 60, minWidth: 140 }}
                >
                    {locales.map((code) => (
                        <a
                            key={code}
                            className="sidebar__link"
                            href={`/${code}${location.pathname}`}
                        >
                            <img src={FLAG(code)} alt="" style={{ width: 20, borderRadius: 2 }} />
                            {code.toUpperCase()}
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
}

export default function AppLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="app-shell">
            <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
            <main className="app-content">
                <div className="topbar">
                    <button className="topbar__burger" onClick={() => setSidebarOpen(true)} aria-label="menu">
                        <img src="/assets/ds/icons/more_dark.svg" alt="" style={{ width: 20 }} />
                    </button>
                    <div style={{ flex: 1 }} />
                    <LangSwitcher />
                    <span className="avatar avatar--placeholder" title={user ? user.uuid : ''}>
                        {user ? user.uuid.slice(0, 2) : '?'}
                    </span>
                </div>
                <Outlet />
            </main>
        </div>
    );
}

export { PostForm };
